<template>
    <div class="row">
        <div class="col-md-12 mt-3" style="min-height:80vh">
            <h3>How to Select the Right Dosage for Cannabis-Infused Edibles</h3>
            <small class="text-muted">27th October 2020</small>
            
            <p style="text-align:center"><img style="max-width:100%" src="@/assets/articles/edibles_dosage/brownie.jpg" alt="chocolate brownie"/></p>

            <p>Whether you're an edible connoisseur or preparing to make a batch of <i>homemade</i> edibles, there's nothing more important than selecting the right <i>dosage</i> of THC. However, not all of us are skilled mathematicians to dose edibles with the correct ratio of THC properly.</p>

            <p>Edibles provide long-lasting effects, that when dosed correctly, provide an <i>experience of a lifetime</i>. However, when dosed incorrectly, you may face several adverse effects that will make you think twice about your next edible excursion.</p>

            <p>Read along to learn everything there is to know about selecting the right dosage for edibles with the help of a THC calculator that'll make dosing edibles <i>breeze</i>.</p>

            <h4>Why It's Important To Get The Right Dose of THC</h4>

            <p>Whether you consume THC-infused edibles for recreational or medicinal purposes, it's <i>essential</i> to get the right dose.</p>

            <p>The primary reason why you must get the right dose of THC from edibles is due to two reasons.</p>

            <p>First, if you receive <i>too little</i> THC from an edible, the effects will be <i>lackluster</i> and <i>ineffective</i>. Not only does this mean wasted materials from making the edibles, but also time. As a medical marijuana patient, an ineffective edible may mean prolonged pain or the inability to sleep.</p>

            <p>In regards to recreational users, a weak edible may turn your afternoon into a <i>dud</i>. As you can see, there's nothing worse than making a homemade batch of edibles with not enough THC.</p>

            <p>Alternatively, an edible with <i>too much</i> THC may create a series of adverse effects, such as anxiety or black-out sleep. Edibles that are too strong may make even the most seasoned cannabis users fear for their lives — which is never an enjoyable experience.</p>

            <p>Medical marijuana patients and recreational enthusiasts alike won't benefit from edibles with too much THC. As you can see, it's <i>essential</i> to find the proper dosage of THC. In other words, the need for an easy-to-use calculator for edibles is an <i>absolute</i> necessity.</p>

            <h4>Let a Calculator For Edibles Do The Work For You</h4>

            <p style="text-align:center"><img style="max-width:100%" src="@/assets/articles/edibles_dosage/cookies.jpg" alt="chocolate cookies"/></p>

            <p>Instead of scratching your head while trying to dose your edibles properly, it's time to make use of a THC calculator.</p>

            <p><a href="/">Scientific Edible's THC calculator</a> is all you need — aside from your ingredients, of course.</p>

            <p>Our calculator is incredibly easy to use as it allows you to plug in all the relevant information. From the oil of your choice to the potency of your cannabis — the THC calculator figures everything out for you. Check out our <a href="/articles/how_to_use_our_calculator">How To Guide</a> for a step by step guide to calcualting your dosage.</p>

            <p>Once you've plugged in all of the necessary details, the THC Calculator will display the edible’s overall potency. However, the THC calculator goes a step further by providing you with a <i>per-portion dosage</i> as well as dosages for common measurements (teaspoons, cups etc... if you are into that sort of thing).</p>

            <p>Ultimately, Scientific Edible's THC calculator allows you to view homemade edibles’ overall potency and how many <i>portions</i> you can consume to reach your desired dose.</p>

            <p>Lastly, the edibles calculator isn't <i>just</i> for THC, but also for CBD as well. If you're looking for the optimal THC/CBD dosage, there's no better option than this.</p>

            <h4>Effects At Different THC Dosages</h4>

            <p style="text-align:center"><img style="max-width:100%" src="@/assets/articles/edibles_dosage/dropper.jpg" alt="CBD dropper"/></p>

            <p>One of the most unique aspects of edibles and THC/CBD doses is that individuals react differently to the <i>same</i> amount.</p>

            <p>Whereas one person won't feel a <i>thing</i> — another may experience mind-bending potency. However, here is a rough estimation of the dosage to aim for while creating homemade edibles.</p>

            <h5>THC/CBD Dosage For Beginners</h5>

            <p>If you've never consumed THC or CBD infused edibles or have a <i>low tolerance</i> — you must start with a low dosage.</p>

            <p>It's recommended that beginners consume a portion of an edible that's equivalent to 5-10mg of THC. Once you finish the portion, allow 45-minutes to 2-hours for the effects to take effect. If you require a more substantial effect, consume another 5mg of THC. In regards to CBD, the 5-10mg range is also recommended.</p>

            <h5>THC/CBD Dosage For Intermediate Effects</h5>

            <p>If you're ready to increase the dosage, a range of 15-30mg of THC is recommended. For CBD, 15-25mg is the ideal amount for added efficacy.</p>

            <p>At this point, the dosage will be <i>much stronger</i> than that of the dosage meant for beginners and those with a low tolerance.</p>

            <h5>THC/CBD Dosage For Potent Effects</h5>

            <p>If you're one of the few that requires potent effects, a THC dosage of 50mg-100mg is recommended. We must warn you — at these levels, the effects are long-lasting and <i>extremely psychoactive</i>.</p>

            <p>In regards to CBD, 50mg-100mg of CBD is recommended for those that require <i>extensive</i> relief.</p>

            <h4>Dose Responsibly</h4>

            <p>If you're ready to dose with pinpoint accuracy, there's no better option than Scientific Edible's Calculator for edibles.</p>

            <p>Once you find the proper THC/CBD dosage — you'll enjoy every single bite. From saving money on resources to <i>always</i> having an enjoyable experience, there's no reason <i>not</i> to use a THC calculator when making cannabis-infused edibles.</p>

            <h4>Disclaimer</h4>

            <p>Scientific Edible's THC Calculator does not have the accuracy of cannabis testing facilities. You should always treat any estimate as just that: an estimate of the potency. In actual conditions dosage can vary significantly depending on the ingredients used, and the process involved. Regardless of the dosage, it is illegal to operate a vehicle, or any type of heavy machinery, while under the influence of cannabis.</p>

        </div>
    </div>
</template>

<script>
export default {
  components: { },
    metaInfo: {
        title: 'How to Select the Right Dosage for Cannabis-Infused Edibles'
    }
}
</script>

<style>

</style>